import styled from 'styled-components';
import { rgba } from 'polished';

const StyledTextarea = styled.textarea(({ theme }: any) => ({
  width: '100%',
  minHeight: 160,
  padding: 8,
  border: `1px solid ${theme.controlBorderColor}`,
  borderRadius: 2,
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  color: theme.color.default,
  resize: 'vertical',
  boxSizing: 'border-box',
  transition: '0.3s',
  '&::placeholder': {
    color: theme.color.monochrome6,
  },
  '&:hover': {
    borderColor: theme.color.blue6,
  },
  '&:focus': {
    outline: 'none',
    borderColor: theme.color.blue6,
    boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`,
  },
}));

const ProductPickerList = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

const ProductPickerItem = styled.button<{ $selected: boolean }>(
  ({ theme, $selected }: any) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    border: `1px solid ${$selected ? theme.color.blue6 : theme.controlBorderColor}`,
    borderRadius: 4,
    backgroundColor: $selected ? rgba(theme.color.blue6, 0.04) : 'white',
    cursor: 'pointer',
    textAlign: 'left',
    transition: '0.15s',
    '&:hover': {
      borderColor: theme.color.blue6,
    },
    '&:focus': {
      outline: 'none',
      borderColor: theme.color.blue6,
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`,
    },
  }),
);

const ProductPickerLabel = styled.div({
  flex: '1 1 0',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
});

const ProductPickerName = styled.span(({ theme }: any) => ({
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  fontWeight: theme.fontWeight.medium,
  lineHeight: theme.lineHeight.default,
  color: theme.color.default,
}));

const ProductPickerDescription = styled.span(({ theme }: any) => ({
  fontFamily: theme.fontFamily.default,
  fontSize: theme.fontSize.default,
  lineHeight: theme.lineHeight.default,
  color: theme.color.monochrome7,
}));

const ProductPickerCheck = styled.span(({ theme }: any) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 20,
  height: 20,
  flexShrink: 0,
  color: theme.color.blue6,
}));

export {
  StyledTextarea,
  ProductPickerList,
  ProductPickerItem,
  ProductPickerLabel,
  ProductPickerName,
  ProductPickerDescription,
  ProductPickerCheck,
};
